import { observer } from "mobx-react"
import {
    FormControlLabel,
    IconButton,
    Switch,
    Tooltip,
    TextField,
} from "@mui/material"

import { t } from "@lingui/macro"

import { AddCommentRounded } from "@material-ui/icons"

import {
    CardBottomContainer,
    VerticalSeparator,
} from "src/modals/contact-forms-form-builder/styled"

import { IBottomContainerSectionProps } from "src/modals/contact-forms-form-builder/types/bottomContainerSection"

import { FormDetailStore } from "src/modals/contact-forms-form-builder/store"

import { DeleteBinOutlined } from "src/components/icons/DeleteBinOutlined"
import { ContentCopy } from "src/components/icons/ContentCopy"
import { useStore } from "src/store/lib/useStore"
import { GlobalStore } from "src/store"
import { environment } from "src/config/variables"
import { supportsFallbackOption } from "src/modals/contact-forms-form-builder/helper/supportsHiding"

export const BottomContainerSection = observer(
    (props: IBottomContainerSectionProps) => {
        const store = useStore(FormDetailStore)
        const globalStore = useStore(GlobalStore)

        const hasAIChatbotAccess =
            globalStore.session.hasAccessToModule("ai_chatbot")

        return (
            <CardBottomContainer style={{ flexWrap: "wrap", gap: "8px" }}>
                {props.variant === "default" && (
                    <>
                        <FormControlLabel
                            checked={props.isRequired}
                            onChange={() =>
                                props.handleSwitchChange(props.index)
                            }
                            control={<Switch color="success" />}
                            label={t`contact-form-forms-detail-modal.form-field-section.required-label`}
                            sx={{ ml: 1 }}
                        />
                        {hasAIChatbotAccess &&
                            props.handleForceUserChange !== undefined && (
                                <FormControlLabel
                                    checked={props.forceUser ?? false}
                                    onChange={() =>
                                        props.handleForceUserChange?.(
                                            props.index,
                                        )
                                    }
                                    control={<Switch color="success" />}
                                    label="Force user"
                                    disabled={!props.isRequired}
                                    sx={{ ml: 1 }}
                                />
                            )}
                        {hasAIChatbotAccess &&
                            props.handleHiddenChange !== undefined && (
                                <FormControlLabel
                                    checked={props.isHidden ?? false}
                                    onChange={() =>
                                        props.handleHiddenChange?.(props.index)
                                    }
                                    control={<Switch color="success" />}
                                    label="Hide field"
                                    disabled={
                                        !props.isRequired || props.forceUser
                                    }
                                    sx={{ ml: 1 }}
                                />
                            )}
                        {hasAIChatbotAccess &&
                            props.isHidden === true &&
                            props.isRequired === true &&
                            !Boolean(props.forceUser) &&
                            props.fieldType !== undefined &&
                            supportsFallbackOption(props.fieldType) && (
                                <TextField
                                    size="small"
                                    label={t`contact-form-forms-detail-modal.form-field-section.fallback-option-label`}
                                    value={props.fallbackOption ?? ""}
                                    onChange={(e) =>
                                        props.handleFallbackOptionChange?.(
                                            props.index,
                                            e.target.value,
                                        )
                                    }
                                    sx={{ minWidth: 150, ml: 1 }}
                                />
                            )}
                    </>
                )}
                <VerticalSeparator />
                <IconButton
                    size="small"
                    color="inherit"
                    disabled={store.isEditMode}
                    onClick={() => props.handleContentCopyClick(props.index)}
                >
                    <ContentCopy />
                </IconButton>
                <IconButton
                    size="small"
                    color="inherit"
                    disabled={store.isEditMode || props.disableButton}
                    onClick={() => props.handleDeleteClick(props.index)}
                >
                    <DeleteBinOutlined />
                </IconButton>
                {props.handleHelpTextClick !== undefined &&
                    environment !== "production" && (
                        <Tooltip
                            title={t`contact-form-forms-detail-modal.form-field-section.add-helping-text`}
                            arrow
                        >
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() =>
                                    props.handleHelpTextClick?.(props.index)
                                }
                            >
                                <AddCommentRounded color="action" />
                            </IconButton>
                        </Tooltip>
                    )}
            </CardBottomContainer>
        )
    },
)
